import { render, staticRenderFns } from "./ClickableLink.vue?vue&type=template&id=a34ebdfa&scoped=true&"
import script from "./ClickableLink.vue?vue&type=script&lang=js&"
export * from "./ClickableLink.vue?vue&type=script&lang=js&"
import style0 from "./ClickableLink.vue?vue&type=style&index=0&id=a34ebdfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34ebdfa",
  null
  
)

export default component.exports